import React from 'react';
import './PageSectionTitle.scss';
import { PropTypes } from 'prop-types';
import Icon from '../Icons/Icon';

export const PageSectionArrTextType = PropTypes.arrayOf(
  PropTypes.shape({
    text: PropTypes.string.isRequired,
    isHighlighted: PropTypes.bool,
    isNewLine: PropTypes.bool,
    forDarkScreen: PropTypes.bool,
    icon: PropTypes.string,
  })
);

export const PageSectionTextType = PropTypes.oneOfType([
  PropTypes.string,
  PageSectionArrTextType,
]);

const PageSectionTitle = ({ title, overText, newVersion }) => {
  const className = 'c-PageSectionTitle';
  const newVersionClassName = newVersion ? `${className}--newVersion` : '';

  const isArrTitle = Array.isArray(title);

  const renderArrayTitle = () => {
    return title.map(
      ({ text, isHighlighted, isNewLine, forDarkScreen, icon }, key) => {
        let spanClass = isHighlighted ? `${className}--highlighted` : '';
        let screenVariantClass = forDarkScreen ? `${className}--forDark` : '';

        spanClass = spanClass + ` ${screenVariantClass}`;

        if (isNewLine) {
          spanClass = spanClass + ` ${className}--newline`;
        }

        if (newVersion) {
          spanClass = spanClass = ` ${className}--newVersion`;
        }

        if (icon) {
          return (
            <span className={`${className}__icon`}>
              <Icon name={icon} />
            </span>
          );
        }
        return (
          <span key={key} className={spanClass}>
            {text}
          </span>
        );
      }
    );
  };

  return (
    <p className={`${className} ${newVersionClassName}`}>
      {overText && <span className={`${className}__overText`}>{overText}</span>}
      {isArrTitle ? renderArrayTitle() : title}
    </p>
  );
};

PageSectionTitle.defaultProps = {
  title: '',
  overText: '',
};

PageSectionTitle.propTypes = {
  title: PageSectionTextType,
  overText: PropTypes.string,
};

export default PageSectionTitle;
